import { Link } from '@tanstack/react-router'

import { openCookieSettings } from '@/components/CookieNotice'
import { POSTHOG_KEY } from '@/lib/analytics/posthog'
import { PHONE } from '@/lib/contact'
import Logo from './Logo'

const columns: {
  heading: string
  links: { label: string; to?: string; href?: string }[]
}[] = [
  {
    heading: 'Product',
    links: [
      { label: 'Overview', to: '/' },
      { label: 'Pricing', to: '/pricing' },
      { label: 'Dashboard', to: '/dashboard' },
      { label: 'Sign up', to: '/signup' },
    ],
  },
  {
    heading: 'Resources',
    links: [
      { label: 'Docs', to: '/docs' },
      { label: 'Quickstart', to: '/docs/quickstart' },
      { label: 'Blog', to: '/blog' },
      { label: 'Support', to: '/support' },
    ],
  },
  {
    heading: 'Legal',
    links: [
      { label: 'Terms', to: '/terms' },
      { label: 'Privacy', to: '/privacy' },
      { label: 'Cancellation', to: '/cancellation' },
      { label: 'Acceptable use', to: '/acceptable-use' },
    ],
  },
]

const linkClass =
  'text-sm text-muted-foreground transition-colors hover:text-foreground'

export default function Footer() {
  return (
    <footer className="border-t bg-muted/20">
      <div className="mx-auto w-full max-w-5xl px-6 py-14">
        <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-[1.4fr_repeat(3,1fr)]">
          <div className="flex flex-col gap-3">
            <Logo className="h-6 w-auto self-start" />
          </div>

          {columns.map((col) => (
            <div key={col.heading} className="flex flex-col gap-3">
              <h3 className="text-sm font-medium">{col.heading}</h3>
              <ul className="flex flex-col gap-2">
                {col.links.map((link) => (
                  <li key={link.label}>
                    {link.to ? (
                      <Link to={link.to} className={linkClass}>
                        {link.label}
                      </Link>
                    ) : (
                      <a href={link.href} className={linkClass}>
                        {link.label}
                      </a>
                    )}
                  </li>
                ))}
                {/* Withdrawing consent has to be as easy as giving it, so the
                    notice needs a way back. Only rendered where analytics is
                    actually configured — with no key there is nothing to
                    change and CookieNotice never mounts. */}
                {col.heading === 'Legal' && POSTHOG_KEY ? (
                  <li>
                    <button
                      type="button"
                      className={linkClass}
                      onClick={openCookieSettings}
                    >
                      Cookie settings
                    </button>
                  </li>
                ) : null}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 border-t pt-6 text-sm text-muted-foreground">
          <p>© {new Date().getFullYear()} Masklabs US LLC</p>
          <address className="mt-1 not-italic">
            1309 Coffeen Ave STE 1200
            <br />
            Sheridan, WY 82801
            <br />
            <a
              href={`tel:${PHONE.tel}`}
              className="transition-colors hover:text-foreground"
            >
              {PHONE.display}
            </a>
          </address>
        </div>
      </div>
    </footer>
  )
}
